export enum NotificationType {
  START_DATE = 'START_DATE_NOTI',
  END_DATE = 'END_DATE_NOTI',
  MID_DATE = 'MID_DATE_NOTI',
  REPORT = 'REPORT',
  APPOINTMENT = 'APPOINTMENT',
  CONTRACT = 'CONTRACT',
  PROPOSAL = 'PROPOSAL',
  PAYMENT = 'PAYMENT',
  LIQUIDATION = 'LIQUIDATION',
  BUILDING = 'BUILDING',
  CONTRACT_OVERVIEW = 'CONTRACT_OVERVIEW',
  APPENDIX_OVERVIEW = 'APPENDIX_OVERVIEW',
  ACCEPTANCE_OVERVIEW = 'ACCEPTANCE_OVERVIEW',
  EXTENSION_OVERVIEW = 'EXTENSION_OVERVIEW',
  ADS_PLAN_OVERVIEW = 'ADS_PLAN_OVERVIEW',
  GDKD_REJECTED = 'GDKD_REJECTED',
  OPERATION_REPORT = 'OPERATION_REPORT'
}

export enum NotificationModule {
  CRM = 'CRM',
  BUILDING = 'BUILDING',
  CONTRACT = 'CONTRACT',
  BOOKING = 'BOOKING'
}
